<template lang="pug">
  CoverSection.DrawerCover
    transition(mode="out-in" :name="transitionType")
      .DrawerCover_imgContainer(:key="model.coverThumbnail")
        ZoomableImg(:isSample="isSample", :src="model.allImages").DrawerCover_image

    ButtonSimple(:to="model.collection.url") {{ model.collection.title }}

    .DrawerCover_title
      router-link.DrawerCover_navLink.DrawerCover_navLink-prev(:to="model.prevDrawer" @click.native="direction = -1" v-if="model.prevDrawer")
        SvgInline.first(src="arrow-line-left")
        SvgInline.second(src="arrow-line-left")
      span {{ $t('collection.drawer') }} {{ model.name }}
      router-link.DrawerCover_navLink.DrawerCover_navLink-next(:to="model.nextDrawer" @click.native="direction = 1" v-if="model.nextDrawer")
        SvgInline.first(src="arrow-line-right")
        SvgInline.second(src="arrow-line-right")

</template>

<script>

import SvgInline from '@/components/SvgInline'
import ButtonSimple from '@/components/common/ButtonSimple'
import ZoomableImg from '@/components/common/ZoomableImg'
import CoverSection from '@/components/common/CoverSection'

export default {
  props: ['model'],
  components: { ButtonSimple, SvgInline, ZoomableImg, CoverSection },
  data () {
    return {
      direction: 1, // 1 ou -1
      nextDrawer: '',
      previousDrawer: '',
      isSample: false
    }
  },
  computed: {
    previousDrawerUrl () {
      return this.previousDrawer ? this.previousDrawer.url : ''
    },
    nextDrawerUrl () {
      return this.nextDrawer ? this.nextDrawer.url : ''
    },
    transitionType () {
      return this.direction === 1 ? 'normal' : 'reverse'
    }
  }
}

</script>

<style lang="stylus">

  .DrawerCover

    .ZoomableImg

      img
        width: 60%
        max-width: 900px
        height: auto

</style>

<style lang="stylus" scoped>

  .DrawerCover
    text-align center
    z-index 2
    background-color $black
    color white

    .ButtonSimple
      margin 0 auto 25px

      @media $mq_s_only

        padding 10px 15px
        max-height 62px
        display block
        overflow hidden

      @media $mq_s_only

        padding 10px 15px
        max-height 62px
        max-width 70%
        display block
        overflow hidden

    &_title
      letter-spacing: 0.15em;
      display block
      margin-left auto
      margin-right auto
      text-transform uppercase
      margin-bottom 20px

      &:hover

        span

          margin 0px 20px

          @media $mq_s_only

            margin auto 8px

          @media $mq_m

            margin auto 30px

      @media $mq_s_only
        font-size: 14px;

      @media $mq_m
        margin-bottom 4.5vw

      span

        margin auto 15px
        transition margin 0.8s $ease
        vertical-align middle

        @media $mq_s_only

          margin auto 8px
          font-size 12px

        @media $mq_m
          margin auto 25px

      svg

        margin auto
        vertical-align middle
        width 45px

        @media $mq_m
          width 65px

    .DrawerCover_navLink-prev

      cursor w-resize

      .first

        left 0px

      .second

        left 130%

    .DrawerCover_navLink-next

      cursor e-resize

      .first

        right 0px

      .second

        right 130%

    &_navLink

      transition all 0.8s $ease
      overflow-x hidden
      display inline-block
      width 65px
      height 10px
      position relative

      @media $mq_s_only

        width 45px

      svg

        position absolute
        top 50%
        transition all 0.8s cubic-bezier(0.77, 0, 0.175, 1);
        transform translateY(-50%)

      &:hover

        opacity 0.5

        &.DrawerCover_navLink-prev

          .first

            left -130%

          .second

            left 0%

        &.DrawerCover_navLink-next

          .first

            right -130%

          .second

            right 0%

      &.is-disabled
        opacity: 0
        pointer-events: none

    &_imgContainer
      position: relative
      flex-grow: 1
      height 0 // debug, si pas de taille au départ, l'image agrandi le container (la taille sera défini par flexbox)
      padding 20px
      display: flex
      justify-content: center
      align-items center

      &.normal-enter,
      &.reverse-leave-to
        transform translate3d(200px, 0, 0)
        opacity 0

      &.normal-leave-to,
      &.reverse-enter
        transform translate3d(-200px, 0, 0)
        opacity 0

      &.normal-enter-active
      &.reverse-enter-active
        transition all 1.2s $ease

      &.normal-leave-active
      &.reverse-leave-active
        transition all 1s $ease

      @media $mq_m
        padding 40px

      @media $mq_l
        padding 65px

    &_image

      width auto
      height auto
      text-align center

      img

        width 75%

</style>
